export const BONDS_STORE_NAME = 'bonds';
export const ABS_ASSET_CLASS_ID = '4549f728-3f71-4566-b114-c8dfb3ccb261';
export const DEFAULT_PER_PAGE = 10;
export const DEFAULT_PAGE = 1;
export const BONDS_TILE_HEADER_MAPPING_NAME = 'bondBlock';
export const TRACE_TILE_HEADER_MAPPING_NAME = 'traceBlock';

export const initialInventoriesData = {
  inventories: {
    collection: [],
    totalCount: 0,
  },
  lastImportAt: null,
  subscriptionStatus: {
    subscriptionId: null,
    isSubscribed: null,
    subscriptionName: '',
    subscriptionSubgroupName: '',
  },
};

export const initialBwicData = {
  bwics: {
    collection: [],
    totalCount: 0,
  },
  lastImportAt: null,
  subscriptionStatus: {
    subscriptionId: null,
    isSubscribed: null,
    subscriptionName: '',
    subscriptionSubgroupName: '',
  },
};

export const initialFiltersState = {
  sortBy: '',
  sortOrder: '',
  page: 1,
  perPage: 25,
  search: '',
};

export const defaultFiltersPayload = {
  dateFrom: null,
  dateTo: null,
  includedStatus: 'all',
  includedSubsectorIds: [],
  includedIssuerIds: [],
  includedDealerIds: [],
  includedBenchmarkGroupIds: [],
  includedSpeedTypeIds: [],
  includedRatingGroupIds: [],
  includedRatingAgencyIds: [],
  currentFaceRangeIds: [],
  includedSectorIds: [],
  includedDealIds: [],
  includedParentIds: [],
  excludedSectorIds: [],
  includedIndustryIds: [],
  includedSubindustryIds: [],
  includedCurrentFaces: [
    {
      includedCurrentFaceFrom: null,
      includedCurrentFaceTo: null,
    },
  ],
  includedWalFrom: null,
  includedWalTo: null,
  includedSpreadFrom: null,
  includedSpreadTo: null,
  includedSpeedFrom: null,
  includedSpeedTo: null,
};

export const defaultTileFilterPayload = {
  perPage: DEFAULT_PER_PAGE,
  page: DEFAULT_PAGE,
  search: '',
};
